import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { ToastContext } from './contexts';
import { usePage } from '~/__modules__/page';

const SHOW_TIME_MS = 3 * 1000;
const PORTAL_ROOT_ID = 'toast-root';

ToastProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
export default function ToastProvider({ children }) {
  const { t } = useTranslation();
  const { language } = usePage();

  const portalRootElemRef = useRef(document.getElementById(PORTAL_ROOT_ID));
  useEffect(() => {
    if (portalRootElemRef.currrent) return;

    const elem = document.createElement('div');
    elem.id = PORTAL_ROOT_ID;
    document.body.appendChild(elem);
    portalRootElemRef.current = document.getElementById(PORTAL_ROOT_ID);
  }, []);

  const [message, setMessage] = useState();
  const timerRef = useRef();
  useEffect(() => {
    clearTimeout(timerRef.current);
    if (!_.isEmpty(message)) {
      timerRef.current = setTimeout(() => setMessage(), SHOW_TIME_MS);
    }
  }, [message]);

  const handleClickClose = () => setMessage();

  return (
    <ToastContext.Provider value={{ setMessage }}>
      {children}
      {!_.isEmpty(message) &&
        ReactDOM.createPortal(
          <div className={classNames('toast_container', language)}>
            <div className="layer_toast">
              <div className="toast_contents">
                <p className="msg">{message}</p>
              </div>
              <button className="btn_close" onClick={handleClickClose}>
                <span className="blind">{t('button_close')}</span>
              </button>
            </div>
          </div>,
          portalRootElemRef.current,
        )}
    </ToastContext.Provider>
  );
}
